"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFooterCtx = exports.footerCtx = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Button_1 = tslib_1.__importDefault(require("../Button"));
var ConfigProvider_1 = require("../ConfigProvider");
var hooks_1 = require("../utils/hooks");
var promise_1 = require("../utils/promise");
// 用于 Modal 与 ModalFooter 间交互的 context
exports.footerCtx = react_1.createContext({});
/** 获取用于自定义 Footer 实现的上下文信息 */
function useFooterCtx() {
    return react_1.useContext(exports.footerCtx);
}
exports.useFooterCtx = useFooterCtx;
function Footer(_a) {
    var _this = this;
    var okText = _a.okText, cancelText = _a.cancelText, _b = _a.okType, okType = _b === void 0 ? 'primary' : _b, _c = _a.cancelType, cancelType = _c === void 0 ? 'default' : _c, _d = _a.okLoading, okLoading = _d === void 0 ? false : _d, _e = _a.okButtonProps, okButtonProps = _e === void 0 ? {} : _e, _f = _a.cancelButtonProps, cancelButtonProps = _f === void 0 ? {} : _f;
    var langData = ConfigProvider_1.useLangData('modal');
    var _g = useFooterCtx(), onOk = _g.onOk, onCancel = _g.onCancel;
    var _h = hooks_1.useSafeState(false), loading = _h[0], setLoading = _h[1];
    var handleOk = react_1.useCallback(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var returns;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    returns = onOk === null || onOk === void 0 ? void 0 : onOk();
                    if (!promise_1.isPromise(returns)) return [3 /*break*/, 4];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, returns];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [onOk, setLoading]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, tslib_1.__assign({ type: okType, onClick: handleOk, loading: okLoading || loading }, okButtonProps), okText !== null && okText !== void 0 ? okText : langData.okText),
        react_1.default.createElement(Button_1.default, tslib_1.__assign({ onClick: onCancel, type: cancelType }, cancelButtonProps), cancelText !== null && cancelText !== void 0 ? cancelText : langData.cancelText)));
}
exports.default = Footer;
//# sourceMappingURL=Footer.js.map